export default {
  baseUrl: null,
  init() {
    const AJS = window.AJS || window.parent.AJS;
    this.baseUrl = AJS.contextPath();
    return this.baseUrl;
  },
  getIssueDescriptionHost() {
    return '';
  },
};
